import { useRouter, useTranslation } from '@wbk/config';
import EventsFullScreenCarousel from '@/components/sections/common/FeaturedEvents';
import { useGetEventsList } from '@/hooks/use-get-events';
import type { ContentfulEvent, WebSection } from '@wbk/contentful/api';

type Props = {
  event: ContentfulEvent;
};

const FeaturedFullScreen = ({ event }: Props) => {
  const { locale } = useRouter();
  const { t } = useTranslation(['common']);

  const { data } = useGetEventsList(
    {
      lang: locale,
      limit: 12,
      where: {
        AND: [{ slug_not: event.slug }, { season: { slug: 'riyadh-season-2025' } }],
      },
    },
    { enabled: !!event }
  );

  const items = data?.items || [];
  if (!items.length) return null;

  const section: WebSection = {
    id: 'featured-fullscreen',
    title: t('common:featured'),
    renderType: 'fullwidth-carousel',
    categoriesCollection: { items: [] },
    contentCollection: { items: items as unknown as WebSection['contentCollection']['items'] },
    webLinksCollection: { items: [] },
  } as unknown as WebSection;

  return (
    <section className='py-40'>
      <EventsFullScreenCarousel section={section} withoutTitle />
    </section>
  );
};

export default FeaturedFullScreen;
